<script lang="ts" setup>
import type { SectionsRichTextColumnsGroup } from '@autobid/strapi-integration/rest/components'

interface Props {
  data: SectionsRichTextColumnsGroup
}

defineProps<Props>()
</script>

<template>
  <elements-expander
    :id="data.anchor"
    class="flex flex-wrap gap-y-6"
    :expander="data.expander"
    :class="{
      'justify-end': data.alignedContent?.name === 'right',
      'justify-center': data.alignedContent?.name === 'center',
    }"
  >
    <SectionsRichTextCkeditor
      v-for="editor in data.richtexts"
      :key="editor.id"
      :data="editor"
    />
  </elements-expander>
</template>
